import Phaser from 'phaser';
import { resolveInvitation } from '../config/invitations';
import { GAME_HEIGHT, GAME_WIDTH } from '../config/game';
import { parseBannerMarkup } from '../utils/bannerMarkup';
import { addSky } from './sceneArt';

export class InvitationScene extends Phaser.Scene {
  constructor() { super('InvitationScene'); }
  create(): void {
    addSky(this);
    this.add.rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2, GAME_WIDTH, GAME_HEIGHT, 0x10162e, 0.45);
    const panel = this.add.rectangle(195, 430, 350, 565, 0xffeaa2).setStrokeStyle(8, 0x172142).setDepth(5);
    this.add.image(55, 190, 'star').setDisplaySize(42, 42).setDepth(6);
    this.add.image(335, 190, 'star').setDisplaySize(42, 42).setDepth(6);
    const { bannerText } = resolveInvitation(window.location.search);
    const lines = parseBannerMarkup(bannerText);
    const lineHeight = 19;
    const firstLineY = 414 - ((lines.length - 1) * lineHeight) / 2;
    const copy = this.add.container(0, 0).setDepth(7).setAlpha(0);
    lines.forEach((line, index) => {
      const x = line.align === 'left' ? 42 : line.align === 'right' ? 348 : 195;
      const origin = line.align === 'left' ? 0 : line.align === 'right' ? 1 : 0.5;
      copy.add(this.add.text(x, firstLineY + index * lineHeight, line.text, {
        fontFamily: 'PixelFallback, monospace', fontSize: '13px', fontStyle: line.bold ? 'bold' : '', color: '#172142', align: line.align
      }).setOrigin(origin, 0.5));
    });
    const mario = this.add.sprite(78, 188, 'hero-run-1').setDisplaySize(42, 42).setDepth(8).play('hero-run');
    this.tweens.add({ targets: mario, x: 312, yoyo: true, repeat: -1, duration: 2200, ease: 'Linear', onYoyo: () => mario.setFlipX(true), onRepeat: () => mario.setFlipX(false) });
    const koopa = this.add.sprite(72, 676, 'koopa-walk-1').setDisplaySize(38, 38).setOrigin(0.5, 1).setDepth(8).play('koopa-walk');
    const goomba = this.add.sprite(318, 676, 'goomba-walk-1').setDisplaySize(38, 38).setOrigin(0.5, 1).setDepth(8).play('goomba-walk');
    koopa.setFlipX(true);
    this.tweens.add({ targets: koopa, x: 160, yoyo: true, repeat: -1, duration: 1700, ease: 'Linear', onYoyo: () => koopa.setFlipX(false), onRepeat: () => koopa.setFlipX(true) });
    this.tweens.add({ targets: goomba, x: 230, yoyo: true, repeat: -1, duration: 1400, ease: 'Linear' });
    this.tweens.add({ targets: panel, y: { from: 900, to: 430 }, alpha: { from: 0, to: 1 }, duration: 920, ease: 'Cubic.out' });
    this.tweens.add({ targets: copy, alpha: { from: 0, to: 1 }, duration: 640, delay: 360, ease: 'Cubic.out' });
    this.add.text(195, 757, 'TIPPE ZUM NEUSTARTEN', { fontFamily: 'PixelFallback, monospace', fontSize: '10px', color: '#ffffff' }).setOrigin(0.5).setDepth(8).setInteractive().on('pointerdown', () => this.scene.start('StartScene'));
  }
}
